import { useContext } from 'react';
import { assertNever } from '../../../../../Decoders';
import { T, TranslationsContext, translation } from '../../../../../Translations';
import ToggleButton from '../../../../ToggleButton';
import { usePreviewLicense } from './PreviewLicenseContext';

// DVLP-7601: "Show locked courses (N)" in the preview bar. Uses the standard
// Builder v2 ToggleButton — the same control as the "Show Unlicensed
// Programs" filter in edit mode — now that the bar is a light surface. N is
// the courses in this collection the selected license does not unlock; the
// count is omitted until the license options have loaded.

function Label() {
  const { selectedOption, optionsState } = usePreviewLicense();
  switch (optionsState.kind) {
    case 'loading':
    case 'errored':
      return <T kind="Show locked courses" />;
    case 'ready':
      return selectedOption
        .map((o) => (
          <T
            key="count"
            kind="Show locked courses ({{count}})"
            count={Math.max(0, o.total_count - o.unlocks_count)}
          />
        ))
        .getOrElse(() => <T kind="Show locked courses" />);
  }
  return assertNever(optionsState);
}

function LockedCoursesToggle() {
  const ts = useContext(TranslationsContext);
  const { showUnlicensed, setShowUnlicensed, optionsState } = usePreviewLicense();

  return (
    <label
      className="flex items-center gap-3 cursor-pointer select-none"
      data-intercom-target="preview-locked-courses"
    >
      <ToggleButton
        value={showUnlicensed}
        handleOnClick={() => setShowUnlicensed(!showUnlicensed)}
        cursorClassName={optionsState.kind === 'ready' ? 'cursor-pointer' : 'cursor-wait'}
        intercomTarget="preview-show-unlicensed-toggle"
        ariaLabel={translation('Show locked courses')(ts)}
      />
      <span data-intercom-target="preview-show-unlicensed-label">
        <Label />
      </span>
    </label>
  );
}

export default LockedCoursesToggle;
